module.exports = __webpack_public_path__ + "fonts/BourgeoisRounded-BoldCondensed.3f2a7c93.eot";